import React from 'react';
import { Accordion } from '../common/Accordion';
import { getValidationOptions } from '../utils';
import { shouldExcludeConditionsAndValidations } from '../constants/fieldTypeGroups';

/**
 * Validations property component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ValidationsProperty = _ref => {
  let {
    field,
    updateValidation,
    accordionStates,
    toggleAccordion
  } = _ref;
  const shouldExclude = shouldExcludeConditionsAndValidations(field.type);
  if (shouldExclude) {
    return null;
  }
  const validationOptions = getValidationOptions(field.type);
  const getValidationLabel = (validationType, fieldType) => {
    const labels = {
      minLength: 'Minimum Length',
      maxLength: 'Maximum Length',
      min: fieldType === 'number' || fieldType === 'range' ? 'Minimum Value' : 'Minimum Date',
      max: fieldType === 'number' || fieldType === 'range' ? 'Maximum Value' : 'Maximum Date',
      pattern: 'Pattern (Regex)',
      customMessage: 'Custom Error Message',
      maxSize: 'Max File Size (MB)',
      allowedTypes: 'Allowed File Types'
    };
    return labels[validationType] || validationType;
  };
  const getValidationPlaceholder = validationType => {
    if (validationType.includes('Length')) {
      return 'Enter number of characters';
    }
    if (validationType === 'maxSize') {
      return 'Enter size in MB';
    }
    return 'Enter value';
  };
  return /*#__PURE__*/_jsx(Accordion, {
    title: "Validations",
    isOpen: accordionStates.validations,
    onToggle: () => toggleAccordion('validations'),
    children: /*#__PURE__*/_jsx("div", {
      className: "validations-section",
      children: validationOptions.map(validationType => {
        const value = field.validations?.[validationType] || '';
        return /*#__PURE__*/_jsxs("div", {
          className: "validation-item",
          children: [/*#__PURE__*/_jsx("label", {
            className: "validation-label",
            children: getValidationLabel(validationType, field.type)
          }), validationType === 'customMessage' ? /*#__PURE__*/_jsx("textarea", {
            value: value,
            onChange: e => updateValidation(validationType, e.target.value),
            className: "validation-input",
            placeholder: "Enter custom error message",
            rows: 2
          }) : validationType === 'pattern' ? /*#__PURE__*/_jsx("input", {
            type: "text",
            value: value,
            onChange: e => updateValidation(validationType, e.target.value),
            className: "validation-input",
            placeholder: "Enter regex pattern"
          }) : validationType === 'allowedTypes' ? /*#__PURE__*/_jsx("input", {
            type: "text",
            value: value,
            onChange: e => updateValidation(validationType, e.target.value),
            className: "validation-input",
            placeholder: "e.g., .pdf,.doc,.jpg"
          }) : /*#__PURE__*/_jsx("input", {
            type: "number",
            value: value,
            onChange: e => updateValidation(validationType, e.target.value ? Number(e.target.value) : ''),
            className: "validation-input",
            placeholder: getValidationPlaceholder(validationType)
          })]
        }, validationType);
      })
    })
  });
};